import useSEO from "../lib/useSEO";
import { BRAND } from "../lib/site-data";

export default function Kvkk() {
    useSEO({
        title: "KVKK Aydınlatma Metni | İstanbul Dövme Silme",
        description: "Kişisel verilerin korunmasına ilişkin aydınlatma metni.",
        canonical: "https://www.istanbuldovmesilme.com/kvkk-aydinlatma-metni",
    });
    return (
        <section className="py-20 md:py-28">
            <div className="max-w-[820px] mx-auto px-6 md:px-12 lg:px-16 prose prose-invert">
                <h1 className="font-display text-4xl md:text-5xl text-white tracking-tight mb-6">
                    KVKK Aydınlatma Metni
                </h1>
                <p className="text-zinc-400 leading-relaxed">
                    İşbu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu
                    ("KVKK") kapsamında, {BRAND.name} ({BRAND.owner}) tarafından sunulan
                    web sitesi ve hizmetler üzerinden tarafınıza ait kişisel verilerin nasıl
                    işlendiğine ilişkin bilgi vermek amacıyla hazırlanmıştır.
                </p>

                <h2 className="font-display text-2xl text-white mt-10 mb-3">1. Veri Sorumlusu</h2>
                <p className="text-zinc-400">
                    {BRAND.name} - {BRAND.owner}, {BRAND.address}.
                </p>

                <h2 className="font-display text-2xl text-white mt-10 mb-3">
                    2. İşlenen Kişisel Veriler
                </h2>
                <ul className="text-zinc-400 list-disc list-inside space-y-1">
                    <li>Ad, soyad</li>
                    <li>Telefon numarası</li>
                    <li>İletişim tercihleri ve mesaj içerikleri</li>
                    <li>Form üzerinden iletilen sağlık ile ilgili tanımlayıcı bilgiler</li>
                </ul>

                <h2 className="font-display text-2xl text-white mt-10 mb-3">
                    3. Verilerin İşlenme Amacı
                </h2>
                <p className="text-zinc-400">
                    Kişisel verileriniz; ön değerlendirme talebinizin yanıtlanması, randevu
                    planlaması, hizmet kalitesinin iyileştirilmesi ve yasal yükümlülüklerin
                    yerine getirilmesi amacıyla işlenmektedir.
                </p>

                <h2 className="font-display text-2xl text-white mt-10 mb-3">4. Veri Saklama Süresi</h2>
                <p className="text-zinc-400">
                    Verileriniz, yasal saklama süreleri ve hizmetin gerektirdiği makul süre
                    boyunca saklanır.
                </p>

                <h2 className="font-display text-2xl text-white mt-10 mb-3">
                    5. Haklarınız
                </h2>
                <p className="text-zinc-400">
                    KVKK 11. madde kapsamındaki tüm haklarınızı kullanmak için yukarıdaki
                    iletişim kanallarımız üzerinden bize ulaşabilirsiniz.
                </p>
            </div>
        </section>
    );
}
